export default {
    'CONTACT.DETAILS.INPUT.FIRST_NAME.LABEL': 'First name',
    'CONTACT.DETAILS.INPUT.LAST_NAME.LABEL': 'Last name',
    'CONTACT.DETAILS.INPUT.PHONE.LABEL': 'Phone',
    'CONTACT.DETAILS.INPUT.COMPANY.LABEL': 'Company',
    'CONTACT.DETAILS.INPUT.COLOR.LABEL': 'Colour',
    'CONTACT.DETAILS.HINT.REQUIRED': 'Required field',
};
